import React, { createContext, useContext } from 'react';
import useSessionTimeout from '../hooks/useSessionTimeout';
import SessionWarningModal from './ui/SessionWarningModal';

const SessionContext = createContext();

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};

export const SessionProvider = ({ children, onSessionExpired }) => {
  const {
    showWarning,
    timeRemaining,
    extendSession,
    formatTimeRemaining
  } = useSessionTimeout(onSessionExpired);

  const handleLogout = () => {
    if (onSessionExpired) {
      onSessionExpired();
    }
  };

  return (
    <SessionContext.Provider value={{
      showWarning,
      timeRemaining,
      extendSession,
      formatTimeRemaining
    }}>
      {children}
      
      <SessionWarningModal
        isVisible={showWarning}
        timeRemaining={timeRemaining}
        onExtendSession={extendSession}
        onLogout={handleLogout}
        formatTimeRemaining={formatTimeRemaining}
      />
    </SessionContext.Provider>
  );
};

export default SessionProvider;